import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-insuranceprofile',
    templateUrl: './insuranceprofile.component.html',
    styleUrls: ['./insuranceprofile.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InsuranceProfileComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
